import React from "react";
import { Route, Switch } from "react-router-dom";
import { PATH_APP } from "../paths";
import { UnProtectedContent } from "./style";
import AuthHeader from "@/components/Auth/AuthHeader";
// import { checkunAuth } from "@/hooks/checkunAuth";
import Forgot from "@/views/Auth/Forgot";
import LogIn from "@/views/Auth/Login";
import ResetPassword from "@/views/Auth/ResetPassword";
import MemberInvite from "@/views/Auth/MemberInvite";
import { NotFound } from "@/views/NotFound";
import { useDispatch } from "react-redux";
import { logout } from "@/redux/slices/auth";

export default function UnProtectedRouter() {
	// 인증이 필요없는 화면들이다.
	// checkunAuth();

	const dispatch = useDispatch();
	React.useEffect(() => {
		dispatch(logout());
	}, [dispatch]);

	return (
		<Route path={PATH_APP.auth.root}>
			<AuthHeader />
			<UnProtectedContent>
				<Switch>
					<Route exact={true} path={PATH_APP.auth.login} component={LogIn} />
					<Route exact={true} path={PATH_APP.auth.forgot} component={Forgot} />
					<Route
						exact={true}
						path={PATH_APP.auth.reset}
						component={ResetPassword}
					/>
					<Route
						exact={true}
						path={PATH_APP.auth.invite}
						component={MemberInvite}
					/>
					<Route component={NotFound} />
				</Switch>
			</UnProtectedContent>
		</Route>
	);
}
